import CheckboxField from "../checkboxField/checkboxField";
import TextAreaField from "../textAreaField/textAreaField";
import { TextWithCheckBoxFieldProps } from "./types/textWithCheckboxFieldProps";
import './textWithCheckboxField.scss';

const TextWithCheckboxField = (props: TextWithCheckBoxFieldProps) => {
    
    return (
        <div style={props.style} className={`textWithCheckbox ${props.className}`}>
            <TextAreaField {...props.textAreaProps} />
            <CheckboxField {...props.checkBoxProps} />
        </div>
    )
}

export default TextWithCheckboxField;